import Checkbox from '@/components/UI/FormElements/Checkbox';
import Icon from '@/components/UI/Icon';
import type { ID } from '@/model/Common.model';
import { FC } from 'react';

interface RequiredCheckboxCellProps {
  itemId?: ID;
  isEditing: boolean;
  isEditable: boolean;
  required: boolean;
  tempRequired?: boolean;
  isSaving?: boolean;
  isActive?: boolean;
  onChange: (itemId: ID, checked: boolean) => void;
  testIdPrefix?: string;
}

export const RequiredCheckboxCell: FC<RequiredCheckboxCellProps> = ({
  itemId,
  isEditing,
  isEditable,
  required,
  tempRequired,
  isSaving = false,
  isActive = true,
  onChange,
  testIdPrefix = 'field',
}) => {
  if (isEditing && isEditable && itemId) {
    return (
      <div className="h-100 flex items-center justify-center checkbox-container-width">
        <Checkbox
          checked={tempRequired ?? required}
          onChange={(e) => onChange(itemId, e.target.checked)}
          disabled={isSaving || !isActive}
          data-testid={`required-checkbox-${testIdPrefix}`}
        />
      </div>
    );
  }

  return (
    <div
      className="checkbox-container h-100 flex items-center justify-center checkbox-container-width"
      data-testid={`required-indicator-${testIdPrefix}`}
    >
      {required && <Icon icon="checkbox" width="16" height="16" className={!isActive ? 'light-gray' : 'dark-gray'} />}
    </div>
  );
};
